import { useEffect, useRef, useState } from 'react'
import { CustomFloatingFilterProps } from 'ag-grid-react'
import { FilterInput } from '../../filter/common'
import { TextFilterOperator } from '../../filter/TextFilter'

export type Props = CustomFloatingFilterProps

export const ServerSideTextFloatingFilter = ({
  model,
  onModelChange,
}: Props) => {
  const inputRef = useRef<HTMLInputElement>(null)
  const [isComposing, setIsComposing] = useState<boolean>(false)
  // IME composition 中は localValue で保持し、確定後に onModelChange する
  const [localValue, setLocalValue] = useState<string>('')

  // 親フィルター変更時にローカル表示を同期
  useEffect(() => {
    const parentValue = (model?.value as string) ?? ''
    if (!isComposing) {
      setLocalValue(parentValue)
      if (inputRef.current) {
        inputRef.current.value = parentValue
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- model の変更のみをトリガーとする。isComposing は composition 中に親モデル同期をスキップするためのガード
  }, [model])

  const changeModel = (v: string) => {
    onModelChange(
      v
        ? {
            operator: TextFilterOperator.CONTAINS,
            ...(model ?? {}),
            value: v,
          }
        : null
    )
  }

  return (
    <FilterInput
      ref={inputRef}
      value={localValue}
      onChange={e => {
        const v = e.target.value ?? ''
        setLocalValue(v)
        if (!isComposing) {
          changeModel(v)
        }
      }}
      onCompositionStart={() => setIsComposing(true)}
      onCompositionEnd={e => {
        setIsComposing(false)
        const v = (e.target as HTMLInputElement).value ?? ''
        setLocalValue(v)
        changeModel(v)
      }}
      sx={{ backgroundColor: '#ffffff' }}
    />
  )
}
